import { render } from "./button.vue?vue&type=template&id=1e668268"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=1e668268&lang=css"
script.render = render

export default script